import ProPilot from './ProPilot';
import ProPilotActive from './ProPilotActive';
import ParkAssist from './ParkAssist';
import ParkAssistPrologue from './ParkAssistPrologue';
import ParkAssistActive from './ParkAssistActive';
import RemoteParking from './RemoteParking';
import RemoteParkingPrologue from './RemoteParkingPrologue';
import RemoteParkingActive from './RemoteParkingActive';

const Scenes = {
    ProPilot,
    ProPilotActive,
    ParkAssist,
    ParkAssistPrologue,
    ParkAssistActive,
    RemoteParking,
    RemoteParkingPrologue,
    RemoteParkingActive,
};

export default Scenes;
